"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.VisitCollector = void 0;
var VisitCollector = (function () {
    function VisitCollector(window, document, url, getGaId, getUtId, logger, lsPrefix, settingsName) {
        var _this = this;
        if (lsPrefix === void 0) { lsPrefix = '_ut:'; }
        if (settingsName === void 0) { settingsName = '_utTrackerSettings'; }
        this.window = window;
        this.document = document;
        this.url = url;
        this.getGaId = getGaId;
        this.getUtId = getUtId;
        this.logger = logger;
        this.lsPrefix = lsPrefix;
        this.settingsName = settingsName;
        this.visit = 'VISIT';
        this.hit = 'HIT';
        this.sessionIdKey = 'session_id';
        this.lastActionAtKey = 'last_action_at';
        this.referrer = this.document.referrer;
        this.settings = {
            sessionDuration: 30 * 60 * 1000
        };
        this.generateUUID = function () {
            var d = Date.now();
            return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
                var r = (d + Math.random() * 16) % 16 | 0;
                d = Math.floor(d / 16);
                return (c == 'x' ? r : (r & 0x3) | 0x8).toString(16);
            });
        };
        this.saveToLS = function (key, value) {
            return _this.window.localStorage.setItem(_this.lsPrefix + key, "" + value);
        };
        this.getFromLS = function (key) { return _this.window.localStorage.getItem(_this.lsPrefix + key); };
        this.getSessionId = function () { return _this.getFromLS(_this.sessionIdKey) || _this.resetSession(); };
        this.resetSession = function () {
            var sessionId = _this.generateUUID();
            _this.saveToLS(_this.sessionIdKey, sessionId);
            _this.saveToLS(_this.lastActionAtKey, 0);
            return sessionId;
        };
        this.onLogin = function (userId) {
            if (_this.userId && _this.userId !== userId) {
                _this.resetSession();
            }
            _this.userId = userId;
            _this.send();
        };
        this.onLogout = function () {
            _this.userId = undefined;
            _this.resetSession();
        };
        this.safeValue = function (value) {
            if (value) {
                return encodeURIComponent(value);
            }
            return '';
        };
        this.getHostname = function (url) { return url.split(/\/+/, 2)[1]; };
        this.getIsNewSession = function () {
            var lastActionAt = _this.getFromLS(_this.lastActionAtKey) || 0;
            return (Date.now() - +lastActionAt > _this.settings.sessionDuration ||
                _this.getHostname(_this.referrer) !== _this.window.location.host);
        };
        this.removeNode = function (node) {
            if (node && node.parentNode) {
                node.parentNode.removeChild(node);
            }
        };
        this.request = function (payload) {
            var querystring = Object.keys(payload)
                .map(function (key) { return key + "=" + _this.safeValue(payload[key]); })
                .join('&');
            var img = _this.document.createElement('img');
            img.onload = function () {
                _this.removeNode(img);
            };
            img.onerror = function () {
                _this.removeNode(img);
            };
            img.src = _this.url + "?" + querystring;
            _this.document.head.appendChild(img);
        };
        this.send = function (options) { return __awaiter(_this, void 0, void 0, function () {
            var currentUrl, isNewSession, utId, gaId, hashString, payload;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.logger.debug('Trying to send analytics');
                        currentUrl = this.window.location.href;
                        isNewSession = this.getIsNewSession();
                        return [4, this.getUtId().catch(function (error) {
                                _this.logger.error('UT id error: ', error);
                                return '';
                            })];
                    case 1:
                        utId = _a.sent();
                        return [4, this.getGaId().catch(function (error) {
                                _this.logger.error('GA id error: ', error);
                                return '';
                            })];
                    case 2:
                        gaId = _a.sent();
                        hashString = this.encodeHashData(options === null || options === void 0 ? void 0 : options.hashData);
                        payload = {
                            requestId: this.generateUUID(),
                            type: isNewSession ? this.visit : this.hit,
                            target: "" + currentUrl + hashString,
                            referrer: this.referrer,
                            clientId: utId,
                            sessionId: isNewSession ? this.resetSession() : this.getSessionId(),
                            gaId: gaId,
                            userId: this.userId || ''
                        };
                        this.request(payload);
                        this.saveToLS(this.lastActionAtKey, Date.now());
                        this.referrer = payload.target;
                        return [2];
                }
            });
        }); };
        this.window.isVisitCollector = true;
        this.origPushState = this.window.history.pushState;
        this.window.addEventListener('popstate', function () {
            _this.send();
        });
        this.window.history.pushState = function () {
            var rest = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                rest[_i] = arguments[_i];
            }
            setTimeout(_this.send, 0);
            _this.origPushState.apply(window.history, Array.prototype.slice.call(rest));
        };
        this.referrer = this.document.referrer;
        this.settings = Object.assign(this.settings, this.window[this.settingsName]);
        this.send();
    }
    VisitCollector.prototype.encodeHashData = function (hashData) {
        if (!hashData)
            return '';
        return "#!" + new URLSearchParams(hashData).toString();
    };
    return VisitCollector;
}());
exports.VisitCollector = VisitCollector;
//# sourceMappingURL=VisitCollector.js.map